import { Component, OnInit } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { Router, Scroll } from '@angular/router';
import { filter } from 'rxjs';
import { RouterLink } from '@angular/router';
import { NavMenu } from '../nav-menu/nav-menu';

@Component({
  selector: 'app-court-documents',
  templateUrl: './court-documents.html',
  styleUrls: ['./court-documents.css'],
  imports: [NavMenu],
})
export class CourtDocuments implements OnInit {

  constructor(
    private router: Router,
    private viewportScroller: ViewportScroller ) { }

  ngOnInit() {
    this.router.events.pipe(
      filter((e: any): e is Scroll => e instanceof Scroll)
    ).subscribe(e => {
      if (e.position) {
        this.viewportScroller.scrollToPosition(e.position);
      } else if (e.anchor) {
        this.viewportScroller.scrollToAnchor(e.anchor);
      } else {
        this.viewportScroller.scrollToPosition([0, 0]);
      }
    });
  }

}
